let ppp = 9; // Post per page
// let pageNumber = 1;



function LoadMoreInsights(){
    jQuery("#load_more_posts").on("click", function(){
        // jQuery("#once_more_posts").attr("disabled",true); // Disable the button, temp.
        console.log("load more posts");
       load_posts();
    })
}
function load_posts(){
      
   // let insightYear = jQuery('.insight__year-list').val();
    let pageNumber = jQuery("#load_more_posts").attr("data-page");
    let industryterm = jQuery(".tax-industry").val();
    let contentterm = jQuery(".tax-content_type").val();
    let productterm = jQuery(".tax-product_type").val();
    
    jQuery.ajax({
        type: "POST",
        //dataType: "html",
        url: ajax_posts.ajaxurl,
        data: {
            action:"more_insights_ajax",
            "ppp":ppp,
            "pageNumber":pageNumber,
            industryterm: industryterm,
            contentterm: contentterm,
            productterm: productterm,
        },
        success: function(data){
            
            let resArray = data.split("****");
            console.log(data);
            let $data = jQuery(resArray[0]);
           
                jQuery(".filtered__article").append($data).hide().fadeIn(1000);
                let currentPage = pageNumber;
                pageNumber++;
                  if(resArray[1]<9){
                    jQuery("#load_more_posts").hide();
                  }else if(resArray[2] == currentPage ){   
                    jQuery("#load_more_posts").hide();
                    
                  }else{
                   jQuery("#load_more_posts").show();
                   jQuery("#load_more_posts").attr("data-page", `${pageNumber}`);
                  }
                // jQuery("#once_more_posts").attr("disabled",false);
            // } else{
            //     jQuery("#once_more_posts").attr("disabled",true);
            // }
        }

    });
    return false;
}

export default LoadMoreInsights;